import React from 'react'
import Form from './Form'

const TPSL = ({
  amount,
  contentBuy,
  contentSell,
  conditionalOrOCO,
  marketOrder,
  limit,
  visible,
  setValue,
  triggerPrice,
  selectedMarket,
  subNavigation,
  pricePrecision,
  amountPrecision
}) => {
  return (
    <div>
      <Form
        contentBuy={contentBuy}
        contentSell={contentSell}
        conditionalOrOCO={conditionalOrOCO}
        visible={visible}
        setValue={setValue}
        type={subNavigation.replace(/[^a-zA-Z]/g, '').toLowerCase()}
        selectedMarket={selectedMarket}
        pricePrecision={pricePrecision}
        amountPrecision={amountPrecision}
      />
    </div>
  )
}

export default TPSL
